// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import userGroupsHtml from 'text!html/userGroups.html';
import 'myWorld/uiComponents/dialog';
import 'myWorld/controls/userGroups/userGroupForm';

myw.UserGroupDetails = myw.Dialog.extend({
    id: 'user-group-editor',
    tagName: 'ul',
    className: 'list',

    options: {
        modal: true,
        autoOpen: false,
        minWidth: 490,
        width: 490,
        resizable: true,
        position: { my: 'center', at: 'top+150', of: window },
        buttons: {
            Close: {
                text: '{:close_btn}',
                class: 'right',
                click() {
                    this.close();
                }
            }
        }
    },

    initialize(options) {
        this.owner = options.owner;
        this.app = this.owner.app;
        this.system = this.owner.system;
        this.groupId = options.groupId;

        myw.Dialog.prototype.initialize.call(this, options);
    },

    render() {
        return this.system.getGroup(this.groupId).then(group => {
            this.group = group;

            this.form = new UserGroupForm({
                owner: this,
                model: group
            });

            this.translate(this.$el);
            this.delegateEvents();

            this.options.contents = this.form.$el;
            this.options.title = group.name;

            this.options = _.omit(this.options, 'groupId');
            myw.Dialog.prototype.render.call(this);

            return this.form.$el;
        });
    },

    /**
     * Renders the dialog and makes it visible
     */
    open() {
        return this.render().then(() => this.$el.dialog('open'));
    },

    /*
     * Shows the group window.
     */
    show() {
        this.open();
    },

    /**
     * Hides the dialog
     */
    close() {
        this.$el.dialog('destroy');
    }
});

const detailsHtml = $(userGroupsHtml)
    .filter('#user-group-editor-template')
    .html();

const UserGroupForm = myw.Form.extend({
    messageGroup: 'UserGroupEditor',
    className: 'user-group-editor ui-form',

    events: {
        'click .add-member-btn': 'addMemberToGroup'
    },
    detailsTemplate: _.template(detailsHtml),

    initialize(options) {
        this.isNew = options.isNew;

        const schema = {
            messageGroup: 'UserGroupEditor',
            onChange: options.onChange,
            rows: [
                {
                    components: [
                        new myw.Label({
                            label: `<strong>{:owner}:</strong> ${options.model.owner}`
                        })
                    ]
                },
                {
                    components: [
                        new myw.Label({
                            label: '<strong>{:description}:</strong>'
                        }),
                        new myw.Label({
                            label: options.model.description
                        })
                    ]
                }
            ]
        };

        this.memberViews = [];

        myw.Form.prototype.initialize.call(this, _.extend(schema, options));
        this.options = _.extend(this.options, options);
    },

    render() {
        myw.Form.prototype.render.call(this);
        this.$el.append(this.detailsTemplate({ userHasEditPerm: false }));
        if (!this.isNew) {
            _.each(_.keys(this.options.model.members), member => {
                const memberView = new GroupMember({
                    owner: this,
                    isManager: this.options.model.members[member],
                    name: member
                });
                this.memberViews.push(memberView);
                this.$('.members-list').append(memberView.$el);
            });
        }
    },

    getMembersList() {
        const members = {};

        _.each(this.memberViews, memberView => {
            const memberVal = memberView.getValue();
            _.extend(members, memberVal);
        });
        return members;
    }
});

const groupMemberHtml = $(userGroupsHtml)
    .filter('#group-member-no-edit-template')
    .html();

const GroupMember = Backbone.View.extend({
    tagName: 'li',
    className: 'not-editable',
    messageGroup: 'UserGroupEditor',
    template: _.template(groupMemberHtml),
    initialize(options) {
        this.options = options;
        this.msg = options.owner.msg;
        this.isManager = this.options.isManager;
        this.render();
    },

    render() {
        this.$el.html(this.template(this.options));
    }
});

export default myw.UserGroupDetails;
